// extracted by mini-css-extract-plugin
module.exports = {"controlPane":"ControlPane_controlPane__1TcGp","title":"ControlPane_title__2D5jS","metadata":"ControlPane_metadata__3qXep"};